import "./styles/Footer.css";

function Footer() {
  return (
    <footer id="footer">
      Copyright {new Date().getFullYear()} - Fernando Bouchet
    </footer>
  );
}

export default Footer;
